export const CATEGORIA_CREATE = "CATEGORIA_CREATE";
export const CATEGORIA_UPDATE = "CATEGORIA_UPDATE";
export const CATEGORIA_LOAD = "CATEGORIA_LOAD";
export const CATEGORIA_LOAD_RAIZ = "CATEGORIA_LOAD_RAIZ";
export const CATEGORIA_LOAD_CHILDREN = "CATEGORIA_LOAD_CHILDREN";
export const CATEGORIA_REMOVE = "CATEGORIA_REMOVE";
export const CATEGORIA_ORDENACAO = "CATEGORIA_ORDENACAO";
export const CATEGORIA_LOAD_ALL = "CATEGORIA_LOAD_ALL";
